import useSWR from "swr"

import {
    AppError,
    parseAndThrowAppError,
} from "../../../../errors/errorProcessors"
import { invalidApiDataError } from "../../../../errors/recognisedErrors"
import { getClientProtected } from "../../clients/clients"
import { dnoThresholdMapper } from "../../mappers/dnoThreshold/dnoThresholdMapper"
import { IChangeRequestsResponse } from "../../types/dnoThreshold/dnoThresholdTypes"
import { DNO_THRESHOLD_CHANGE_REQUESTS } from "../../urls/private"

interface IUseGetChangeRequests {
    data: IChangeRequestsResponse | undefined
    error: AppError | null
    isLoading: boolean
    mutate: () => void
}

/**
 * SWR hook to fetch change requests for the current DNO
 * @returns Change requests data, error state, loading state, and mutate function
 */
const useGetChangeRequests = (): IUseGetChangeRequests => {
    const { data, error, isLoading, mutate } = useSWR(
        DNO_THRESHOLD_CHANGE_REQUESTS,
        async (url: string): Promise<IChangeRequestsResponse> => {
            try {
                const res = await getClientProtected(url)
                return dnoThresholdMapper.mapChangeRequests(res)
            } catch (err) {
                const appError = parseAndThrowAppError(err)
                throw invalidApiDataError(appError.message)
            }
        }
    )
    return { data, error, isLoading, mutate }
}

export default useGetChangeRequests
